/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ReleasePaymentRequest
 */
export interface ReleasePaymentRequest {
    /**
     * 
     * @type {Date}
     * @memberof ReleasePaymentRequest
     */
    currencyDate: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ReleasePaymentRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ReleasePaymentRequest
     */
    userVaultId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ReleasePaymentRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof ReleasePaymentRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ReleasePaymentRequest
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ReleasePaymentRequest
     */
    note: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ReleasePaymentRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof ReleasePaymentRequest
     */
    appointmentBookingId: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ReleasePaymentRequest
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Origin}
     * @memberof ReleasePaymentRequest
     */
    origin: Origin;
    /**
     * 
     * @type {string}
     * @memberof ReleasePaymentRequest
     */
    transactionCode?: string | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof ReleasePaymentRequest
     */
    invoiceId?: CreateTimeEntryRequestAppointmentId | null;
}



/**
 * Check if a given object implements the ReleasePaymentRequest interface.
 */
export function instanceOfReleasePaymentRequest(value: object): value is ReleasePaymentRequest {
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userVaultId' in value) || value['userVaultId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('appointmentBookingId' in value) || value['appointmentBookingId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function ReleasePaymentRequestFromJSON(json: any): ReleasePaymentRequest {
    return ReleasePaymentRequestFromJSONTyped(json, false);
}

export function ReleasePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleasePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyDate': (new Date(json['currencyDate'])),
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'userVaultId': ApiUserTasksGetPageParameterFromJSON(json['userVaultId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'amount': json['amount'],
        'currency': json['currency'],
        'note': json['note'],
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'appointmentBookingId': CreateTimeEntryRequestAppointmentIdFromJSON(json['appointmentBookingId']),
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'origin': OriginFromJSON(json['origin']),
        'transactionCode': json['transactionCode'] == null ? undefined : json['transactionCode'],
        'invoiceId': json['invoiceId'] == null ? undefined : CreateTimeEntryRequestAppointmentIdFromJSON(json['invoiceId']),
    };
}

export function ReleasePaymentRequestToJSON(json: any): ReleasePaymentRequest {
    return ReleasePaymentRequestToJSONTyped(json, false);
}

export function ReleasePaymentRequestToJSONTyped(value?: ReleasePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'userVaultId': ApiUserTasksGetPageParameterToJSON(value['userVaultId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'amount': value['amount'],
        'currency': value['currency'],
        'note': value['note'],
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'appointmentBookingId': CreateTimeEntryRequestAppointmentIdToJSON(value['appointmentBookingId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'origin': OriginToJSON(value['origin']),
        'transactionCode': value['transactionCode'],
        'invoiceId': CreateTimeEntryRequestAppointmentIdToJSON(value['invoiceId']),
    };
}

